<template>
  <div class="p-4">
    <header class="mb-4">
      <h1 class="font-size-20 font-weight-700 text-neutral-grey-90 m-0">
        {{ $i18n('.titulo') }}
      </h1>
    </header>

    <div v-if="carregando" class="p-5 text-center bg-cinza-1 rounded text-cinza-5" role="status">
      {{ $i18n('.carregando') }}
    </div>

    <div v-else-if="erroCarregamento" class="p-5 text-center bg-error-10 text-feedback-error-50 rounded" role="alert">
      {{ erroCarregamento }}
    </div>

    <form v-else class="border border-cinza-3 rounded bg-white p-4" @submit.prevent="salvar">
      <div class="form-group">
        <label class="font-weight-700 font-size-12 text-cinza-7" for="tour-nome">
          {{ $i18n('.rotulos.nome') }}
        </label>
        <input
          id="tour-nome"
          v-model="nome"
          type="text"
          class="form-control"
          maxlength="100"
          required
          :placeholder="$i18n('.placeholders.nome')"
        />
      </div>

      <div class="form-group">
        <label class="font-weight-700 font-size-12 text-cinza-7" for="tour-rota">
          {{ $i18n('.rotulos.rota') }}
        </label>
        <input
          id="tour-rota"
          v-model="rotaPattern"
          type="text"
          class="form-control"
          required
          :placeholder="$i18n('.placeholders.rota')"
        />
        <small class="form-text text-cinza-5">
          {{ $i18n('.dicas.rota') }}
        </small>
      </div>

      <section class="mt-3 pt-3 border-top border-cinza-2">
        <h2 class="font-size-14 font-weight-700 text-neutral-grey-90 mt-0 mb-3">
          {{ $i18n('.passos.titulo') }}
        </h2>

        <p v-if="semPassos" class="p-3 bg-cinza-1 rounded text-center text-cinza-5 font-size-12">
          {{ $i18n('.passos.vazio') }}
        </p>

        <TourBuilderStep
          v-for="(passo, idx) in passos"
          :key="passo.id"
          :passo="passo"
          :index="idx"
          :total="passos.length"
          :editando="builder.editando.value === passo.id"
          @editar="builder.editando.value = passo.id"
          @atualizar="(campo, valor) => atualizarPasso(passo, campo, valor)"
          @remover="builder.removerPasso(passo.id)"
          @mover="(direcao) => builder.moverPasso(idx, direcao)"
        />
      </section>

      <div v-if="erroSalvamento" class="alert alert-danger mt-3 mb-0" role="alert">
        {{ erroSalvamento }}
      </div>

      <div class="d-flex justify-content-end pt-3 mt-3 border-top border-cinza-2">
        <a :href="URL_TOURS" class="btn btn-nd-secondary">
          {{ $i18n('.rodape.cancelar') }}
        </a>
        <button
          type="submit"
          class="btn btn-nd-primary ml-2"
          :disabled="salvando || semPassos"
        >
          {{ rotuloBotaoSalvar }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { useTourBuilder } from '../../composables/useTourBuilder.js'
import TourBuilderStep from '../TourBuilderStep.vue'
import mixinTourGuiadoAdmin from './mixinTourGuiadoAdmin'

export default {
  name: 'ToursGuiadosAdminEdit',
  mixins: [mixinTourGuiadoAdmin],
  components: { TourBuilderStep },
  props: {
    tourId: { type: [Number, String], required: true },
    dadosIniciais: { type: Object, default: () => ({}) },
  },
  setup() {
    return { builder: useTourBuilder({ hidratarAtivo: false }) }
  },
  data() {
    return {
      nome: '',
      rotaPattern: '',
      salvando: false,
      erroSalvamento: null,
    }
  },
  computed: {
    passos() {
      return this.builder.passos.value
    },
    semPassos() {
      return this.passos.length === 0
    },
    rotuloBotaoSalvar() {
      return this.$i18n(this.salvando ? '.rodape.salvando' : '.rodape.salvar')
    },
  },
  methods: {
    atualizarPasso(passo, campo, valor) {
      passo[campo] = valor
    },
    aplicarDados(dados) {
      this.nome = dados.nome || ''
      this.rotaPattern = dados.rota_pattern || ''
      this.builder.carregarPassos(Array.isArray(dados.tour_passos) ? dados.tour_passos : [])
    },
    carregar() {
      if (this.dadosIniciais?.id) {
        this.aplicarDados(this.dadosIniciais)
        this.carregando = false
        return
      }
      this.carregarRecurso({
        url: `${this.URL_TOURS}/${this.tourId}/edit.json`,
        chaveErro: 'erros.carregar',
        onSuccess: (dados) => this.aplicarDados(dados),
      })
    },
    validarFormulario() {
      if (!this.nome.trim() || !this.rotaPattern.trim()) {
        this.erroSalvamento = this.$i18n('.erros.campos_obrigatorios')
        return false
      }
      const incompletos = this.passos.filter((p) => !p.titulo?.trim() || !p.descricao?.trim()).length
      if (incompletos > 0) {
        this.erroSalvamento = this.$i18n('.erros.passos_incompletos', { count: incompletos })
        return false
      }
      return true
    },
    salvar() {
      this.erroSalvamento = null
      if (!this.validarFormulario()) return

      this.salvando = true
      this.builder
        .atualizar(this.tourId, this.nome.trim(), this.rotaPattern.trim())
        .then(() => {
          window.location.href = this.URL_TOURS
        })
        .catch((e) => {
          this.erroSalvamento = e.message || this.$i18n('.erros.inesperado_salvar')
        })
        .finally(() => {
          this.salvando = false
        })
    },
  },
}
</script>
